"use strict";
//
// Copyright © 2023 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataAttribute = void 0;
__exportStar(require("./image"), exports);
__exportStar(require("./reference"), exports);
__exportStar(require("./emoji"), exports);
__exportStar(require("./todo"), exports);
__exportStar(require("./file"), exports);
__exportStar(require("./codeblock"), exports);
__exportStar(require("./comment"), exports);
__exportStar(require("./markdown"), exports);
__exportStar(require("./embed"), exports);
var utils_1 = require("./utils");
Object.defineProperty(exports, "getDataAttribute", { enumerable: true, get: function () { return utils_1.getDataAttribute; } });
//# sourceMappingURL=index.js.map